import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { InviteWithStatus } from '../lib/invites.types'
import { UsersService } from '../lib/users.service'
import { useInvitesStatuses } from './useInvitesStatuses'

export const INVITES_LIST_QUERY_KEY = 'invites-list'

export const useInvites = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [INVITES_LIST_QUERY_KEY],
    queryFn: () => UsersService.getInvites(),
    select: data => data.data
  })

  const { data: statuses } = useInvitesStatuses()

  const mappedData: InviteWithStatus[] = useMemo(
    () =>
      data?.map(invite => {
        const currentStatus = statuses?.find(
          status => status.alias === invite.inviteStatus
        )
        return {
          ...invite,
          statusColor: currentStatus?.color || '',
          statusName: currentStatus?.name || '',
          statusIconUrl: currentStatus?.iconUrl || ''
        }
      }) ?? [],
    [data, statuses]
  )

  return {
    data: mappedData,
    isLoading,
    isError,
    error
  }
}
